<div class="settings-page">
  <h1>Settings</h1>

  <div *ngIf="loading()" class="loading">Loading…</div>
  <div *ngIf="error()" class="lm-notice lm-notice--danger">{{ error() }}</div>

  <form *ngIf="!loading() && me()" (ngSubmit)="save()" class="settings-form">
    <div class="form-group">
      <label for="themePreference">Theme</label>
      <select
        id="themePreference"
        name="themePreference"
        [(ngModel)]="themePreference"
        (ngModelChange)="onThemeChange()"
      >
        <option [ngValue]="'SYSTEM'">System</option>
        <option [ngValue]="'LIGHT'">Light</option>
        <option [ngValue]="'DARK'">Dark</option>
      </select>
      <small>System follows this device.</small>
    </div>
    <div class="form-group">
      <label for="timezone">Timezone (IANA)</label>
      <input
        id="timezone"
        name="timezone"
        type="text"
        [(ngModel)]="timezone"
        placeholder="e.g. Europe/London"
        required
      />
    </div>
    <div class="form-group">
      <label for="dayWindowStart">Day starts at (local time)</label>
      <input
        id="dayWindowStart"
        name="dayWindowStartLocalTime"
        type="time"
        [(ngModel)]="dayWindowStartLocalTime"
      />
    </div>
    <div class="form-group">
      <label for="dayWindowEnd">Core Day ends at (local time)</label>
      <input
        id="dayWindowEnd"
        name="dayWindowEndLocalTime"
        type="time"
        [(ngModel)]="dayWindowEndLocalTime"
      />
      <small>Used for Day status planning horizon only; logging day boundaries still follow day start.</small>
    </div>
    <div class="form-group">
      <label for="defaultSlotMinutes">Default slot minutes</label>
      <input
        id="defaultSlotMinutes"
        name="defaultSlotMinutes"
        type="number"
        [(ngModel)]="defaultSlotMinutes"
        [min]="minSlotMinutes"
        [max]="maxSlotMinutes"
        placeholder="40"
      />
    </div>
    <div class="form-group">
      <label for="focusDailyTarget">Daily focus target</label>
      <input
        id="focusDailyTarget"
        name="focusDailyTarget"
        type="number"
        [(ngModel)]="focusDailyTarget"
        [min]="minFocusDailyTarget"
        [max]="maxFocusDailyTarget"
        placeholder="3"
      />
      <small>Advisory limit shown in the Focus view.</small>
    </div>
    <div class="form-group">
      <label for="priorityDailyTarget">Daily priority target</label>
      <input
        id="priorityDailyTarget"
        name="priorityDailyTarget"
        type="number"
        [(ngModel)]="priorityDailyTarget"
        [min]="minFocusDailyTarget"
        [max]="maxFocusDailyTarget"
        placeholder="3"
      />
      <small>Advisory limit shown in the Today's Priorities section.</small>
    </div>
    <div class="form-group">
      <label for="scheduleGroupCount">Number of groupings</label>
      <select id="scheduleGroupCount" name="scheduleGroupCount" [(ngModel)]="scheduleGroupCount">
        <option [ngValue]="1">1</option>
        <option [ngValue]="2">2</option>
        <option [ngValue]="3">3</option>
        <option [ngValue]="4">4</option>
        <option [ngValue]="5">5</option>
      </select>
    </div>
    <div class="form-group">
      <label>Activity groupings</label>
      <div class="schedule-cycle-labels">
        <div>
          <label for="workCycleLabel">Work cycle name</label>
          <input
            id="workCycleLabel"
            name="workCycleLabel"
            type="text"
            [(ngModel)]="workCycleLabel"
            placeholder="Work"
            [maxlength]="cycleLabelMaxLength"
          />
        </div>
        <div>
          <label for="lifeCycleLabel">Life cycle name</label>
          <input
            id="lifeCycleLabel"
            name="lifeCycleLabel"
            type="text"
            [(ngModel)]="lifeCycleLabel"
            placeholder="Life"
            [maxlength]="cycleLabelMaxLength"
          />
        </div>
      </div>
      <div *ngFor="let group of scheduleGroups; let i = index; trackBy: trackScheduleGroup" class="schedule-group-row">
        <strong>{{ resolveGroupLabel(group.ordinal) }}</strong>
        <div class="schedule-group-controls">
          <button
            type="button"
            class="lm-icon-btn"
            [disabled]="!canReorderGroup(group.ordinal, 'up')"
            (click)="reorderGroup(group.ordinal, 'up')"
            aria-label="Move grouping up"
            title="Move grouping up">
            <svg lucideArrowUp class="lm-icon" aria-hidden="true"></svg>
          </button>
          <button
            type="button"
            class="lm-icon-btn"
            [disabled]="!canReorderGroup(group.ordinal, 'down')"
            (click)="reorderGroup(group.ordinal, 'down')"
            aria-label="Move grouping down"
            title="Move grouping down">
            <svg lucideArrowDown class="lm-icon" aria-hidden="true"></svg>
          </button>
        </div>
        <input
          [name]="'scheduleGroupLabel' + i"
          type="text"
          [(ngModel)]="group.label"
          [disabled]="!isGroupEnabled(group.ordinal)"
          placeholder="Custom label"
        />
        <input
          [name]="'scheduleGroupBudgetMinutes' + i"
          type="number"
          [(ngModel)]="group.budgetMinutes"
          [disabled]="!isGroupEnabled(group.ordinal)"
          min="15"
          max="720"
          placeholder="75"
        />
        <select
          [name]="'scheduleGroupCycle' + i"
          [(ngModel)]="group.cycle"
          [disabled]="!isGroupEnabled(group.ordinal)">
          <option value="WORK">{{ resolveCycleDisplayLabel('WORK') }}</option>
          <option value="LIFE">{{ resolveCycleDisplayLabel('LIFE') }}</option>
        </select>
      </div>
      <small>Order is the sequence Day status uses for the day.</small>
      <small>Indicative time for each grouping (minutes per day).</small>
      <small>{{ resolveCycleDisplayLabel('WORK') }} or {{ resolveCycleDisplayLabel('LIFE') }} is the Day status rotation that grouping belongs to.</small>
      <small>Clear a cycle name to reset it to the default.</small>
    </div>
    <button type="submit" class="lm-btn lm-btn--primary" [disabled]="submitting()">
      {{ submitting() ? 'Saving…' : 'Save settings' }}
    </button>
    <p *ngIf="saveSuccess()" class="success">Settings saved.</p>
  </form>
</div>
